export default "/images/70293657d465fce93540597361e4ca39.avif";